import { css, setFlexDFAIC, setProps, styled } from "theme";

interface SFilterInputContainerProps {
  isArabic: boolean;
}

const isArabicLang = setProps<SFilterInputContainerProps>(({ isArabic }) => isArabic)(css`
  flex-direction: row-reverse;
`);

export const SFilterInputContainer = styled.div<SFilterInputContainerProps>`
  ${setFlexDFAIC};
  ${isArabicLang};
`;
